module.exports = __webpack_public_path__ + "static/media/img6.8c6f9c3f.png";